import styled from 'styled-components'

export const Container = styled.div<{ isSessions: boolean }>`
  gap: 24px;
  display: flex;
  align-self: center;
  flex-direction: column;
  margin: ${props => props.isSessions && '16px'};
`
